import gql from "graphql-tag";

export const JPA_GOODIES_SERVICE_GET_MULTI_CSV_SQL = gql`
    query multiCsvSql($arg0: Map_String_List_LongScalar) {
        jpaGoodiesService_multiCsvSql(arg0: $arg0) 
    }
`;